export const getActionFromFormRouteUrl = (
  url: string
): 'add' | 'copy' | 'edit' => {
  const splitted = url.split('/');
  const formSectionIndex = splitted.indexOf('form');

  if (formSectionIndex === -1) {
    throw new Error('Form section not found in URL');
  }

  const action = splitted[formSectionIndex + 2];

  if (action !== 'add' && action !== 'copy' && action !== 'edit') {
    throw new Error('URL has unsupported action section.');
  }

  return action;
};
